import { apiRequest, type ApiMethod, type ApiRequestOptions } from '@/lib/api/client'
import { handleApiAuthError } from '@/lib/auth/handlers'

type JsonRequestOptions = Omit<ApiRequestOptions, 'method'> & {
  handleAuthErrors?: boolean
}

async function requestJson<T>(
  method: ApiMethod,
  path: string,
  { handleAuthErrors = true, ...options }: JsonRequestOptions = {},
): Promise<T> {
  try {
    return await apiRequest<T>(path, { method, handleAuthErrors, ...options })
  } catch (error) {
    if (handleAuthErrors) {
      handleApiAuthError(error, { unauthorizedRedirectPath: '/login' })
    }
    throw error
  }
}

export const api = {
  get: <T>(path: string, options?: JsonRequestOptions) => requestJson<T>('GET', path, options),
  post: <T>(path: string, options?: JsonRequestOptions) => requestJson<T>('POST', path, options),
  patch: <T>(path: string, options?: JsonRequestOptions) => requestJson<T>('PATCH', path, options),
  put: <T>(path: string, options?: JsonRequestOptions) => requestJson<T>('PUT', path, options),
  del: <T>(path: string, options?: JsonRequestOptions) => requestJson<T>('DELETE', path, options),
}
